import { render, staticRenderFns } from "./ItemCropper.vue?vue&type=template&id=526285cb&"
import script from "./ItemCropper.vue?vue&type=script&lang=js&"
export * from "./ItemCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports